import { useEffect, useState } from "react";
import { Lock, Delete, X } from "lucide-react";
import { api } from "@/lib/api";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"];

export const KioskPinDialog = ({ open, onClose, onSuccess }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!open) return;
    setPin("");
    setError("");
    setChecking(true);
    api.get("/kiosk/pin-status")
      .then((r) => (r.data.has_pin ? setChecking(false) : onSuccess()))
      .catch(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const submit = async (value) => {
    try {
      await api.post("/kiosk/verify-pin", { pin: value });
      onSuccess();
    } catch (e) {
      setError(e?.response?.data?.detail || "PIN hatalı");
      setPin("");
    }
  };

  const press = (k) => {
    setError("");
    if (k === "del") return setPin((p) => p.slice(0, -1));
    if (!k || pin.length >= 4) return;
    const next = pin + k;
    setPin(next);
    if (next.length === 4) submit(next);
  };

  if (!open || checking) return null;
  return (
    <div data-testid="kiosk-pin-dialog" className="fixed inset-0 z-[90] grid place-items-center p-4">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative bg-white rounded-3xl w-full max-w-sm p-6 animate-fade-up">
        <button data-testid="kiosk-pin-close" onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-[var(--fb-neutral)]">
          <X className="w-5 h-5" />
        </button>
        <div className="flex flex-col items-center gap-2 mb-5">
          <Lock className="w-8 h-8 text-[var(--fb-red)]" />
          <h2 className="font-display font-extrabold text-xl">Yönetim PIN'i</h2>
          <div className="flex gap-3 mt-2">
            {[0, 1, 2, 3].map((i) => (
              <span key={i} className={`w-4 h-4 rounded-full border-2 border-[var(--fb-ink)] ${pin.length > i ? "bg-[var(--fb-ink)]" : ""}`} />
            ))}
          </div>
          <p data-testid="kiosk-pin-error" className="text-sm font-semibold text-[var(--fb-red)] min-h-[20px] text-center">{error}</p>
        </div>
        <div className="grid grid-cols-3 gap-3">
          {KEYS.map((k, i) => (
            <button
              key={i}
              type="button"
              data-testid={k ? `kiosk-pin-key-${k}` : undefined}
              disabled={!k}
              onClick={() => press(k)}
              style={{ touchAction: "manipulation" }}
              className={`h-16 rounded-2xl font-display font-extrabold text-2xl grid place-items-center ${k ? "bg-[var(--fb-neutral)] active:bg-[var(--fb-border)]" : "invisible"}`}
            >
              {k === "del" ? <Delete className="w-6 h-6" /> : k}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
